import request from "../utils/request"

export function fetchFeedingPlanTemplateList() {
  return request({
    url: "/feeding-plan-templates/admin",
    method: "get"
  })
}

export function createFeedingPlanTemplate(data) {
  return request({
    url: "/feeding-plan-templates/admin",
    method: "post",
    data
  })
}

export function generateFeedingPlanTemplateDraft(data) {
  return request({
    url: "/feeding-plan-templates/admin/ai-draft",
    method: "post",
    data,
    timeout: 90000
  })
}

export function updateFeedingPlanTemplate(id, data) {
  return request({
    url: `/feeding-plan-templates/admin/${id}`,
    method: "put",
    data
  })
}

export function deleteFeedingPlanTemplate(id) {
  return request({
    url: `/feeding-plan-templates/admin/${id}`,
    method: "delete"
  })
}
